module.exports = __webpack_public_path__ + "img/email-seven.9cf52fae.svg";